export const SIMPLE_SCENE_TAG = 'Simple';
export const CANVAS_PRODUCT_ID = 'canvas-product';
